import(/* webpackMode: "eager" */ "/vercel/path0/library/blocks/images/NextImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/blocks/images/NextImageV2.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/library/entities/socialize/bookmark/Bookmark.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/utils/formatters/MomentClient.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
